import Fetch from 'utils/fetch';

export const postSupplierNotes = async (model) => {
    return await Fetch.post('pedido/atualizarObservacaoFornecedor', model).then(({ data }) => data)
}
